"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledWrapper = exports.StyledSelect = exports.StyledLabel = exports.StyledIconWrapper = exports.StyledIcon = exports.StyledHelperText = exports.StyledExpandIcon = exports.StyledDropdownWrapper = exports.StyledDescriptionContainer = void 0;
var _fuseUtils = require("@tvg/fuse-utils");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _iconElement = require("../../fuse-icon-element/src/icon-element");
var _typography = _interopRequireDefault(require("../../fuse-typography-element/src/typography"));
var _config = require("./config");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var borderColor = _config.styledDropdownConfig.borderColor,
  borderRadius = _config.styledDropdownConfig.borderRadius,
  borderWidth = _config.styledDropdownConfig.borderWidth,
  componentName = _config.styledDropdownConfig.componentName,
  helperTextColor = _config.styledDropdownConfig.helperTextColor;
var StyledWrapper = exports.StyledWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styled-dropdown__StyledWrapper",
  componentId: "sc-176ty8k-0"
})(["&.fuse-dropdown--disabled div{background-color:unset;}&.fuse-dropdown--disabled label,&.fuse-dropdown--disabled span,&.fuse-dropdown--disabled p,&.fuse-dropdown--disabled select{color:var(--color-global-grey400);border-color:var(--color-global-grey400);}&.fuse-dropdown--disabled select{color:var(--color-global-grey400);}&.fuse-dropdown--disabled button{color:var(--color-global-grey400);&:hover,&:focus,&:active{outline:none;cursor:initial;}}&.fuse-dropdown--disabled div,&.fuse-dropdown--disabled input{border-color:var(--color-global-grey400);background-color:unset;}&.fuse-dropdown--disabled .", "__expandIcon{background-color:var(--color-global-grey400);}"], componentName);
var StyledLabel = exports.StyledLabel = _styledComponents["default"].label.attrs({
  className: "".concat(componentName, "__label"),
  'data-testid': "".concat(componentName, "__label")
}).withConfig({
  displayName: "styled-dropdown__StyledLabel",
  componentId: "sc-176ty8k-1"
})(["color:var(--color-global-black);display:inline-block;font-weight:var(--font-weight-paragraph);font-size:var(--font-size-1);line-height:var(--font-line-height-1);margin-bottom:var(--spacing-global-space3);", ""], function (_ref) {
  var size = _ref.size;
  return size === 'small' && "\n\t\t\tfont-size: var(--font-size-m2);\n\t\t\tline-height: var(--font-line-height-m2);\n\t\t\tmargin-bottom: var(--spacing-global-space2);\n\t\t";
});
var StyledDropdownWrapper = exports.StyledDropdownWrapper = _styledComponents["default"].div.attrs({
  className: "".concat(componentName, "__wrapper"),
  'data-testid': "".concat(componentName, "__wrapper")
}).withConfig({
  displayName: "styled-dropdown__StyledDropdownWrapper",
  componentId: "sc-176ty8k-2"
})(["background:var(--color-global-white);color:var(--color-global-grey900);display:flex;width:100%;overflow:hidden;align-items:center;", ";", " ", ""], borderRadius, function (_ref2) {
  var state = _ref2.state;
  return "\n\t\tborder: ".concat(borderWidth, " solid ").concat((borderColor === null || borderColor === void 0 ? void 0 : borderColor[state]) || "var(--color-global-grey400)", ";\n\n\t\t").concat(borderRadius, ";\n\n\t\t&.").concat(componentName, "__wrapper--selected {\n\t\t\tborder-color: ").concat((borderColor === null || borderColor === void 0 ? void 0 : borderColor[state]) || "var(--color-global-grey700)", ";\n\t\t}\n\n\t\t&:hover, &:focus, &:focus-within {\n\t\t\tborder-color: ").concat((borderColor === null || borderColor === void 0 ? void 0 : borderColor[state]) || "var(--color-brand-mid)", ";\n\t\t}\n\n\t\t&.").concat(componentName, "__wrapper--outline {\n\t\t\t").concat(_fuseUtils.FocusCss, "\n\t\t}\n\t");
}, function (_ref3) {
  var size = _ref3.size;
  return size === 'small' && "\n\t\theight: 32px;\n\t\toverflow: visible;\n\t";
});
var StyledSelect = exports.StyledSelect = _styledComponents["default"].select.attrs({
  className: "".concat(componentName, "__select"),
  'data-testid': "".concat(componentName, "__select")
}).withConfig({
  displayName: "styled-dropdown__StyledSelect",
  componentId: "sc-176ty8k-3"
})(["background-color:#fff;display:flex;overflow:hidden;padding-top:11px;padding-bottom:11px;padding-left:var(--spacing-global-space4);padding-right:", ";position:relative;text-align:left;transition:all 0.2s;width:100%;margin:0;background-image:none;appearance:none;cursor:pointer;color:var(--color-global-grey900);align-items:center;font-size:var(--font-size-1);line-height:var(--font-line-height-1);border:0;outline:0;margin-right:", ";text-overflow:ellipsis;white-space:nowrap;box-sizing:border-box;", ";&:disabled{cursor:auto;}", ""], function (props) {
  return props.isInDefaultState ? '44px' : '69px';
}, function (props) {
  return props.isInDefaultState ? '-40px' : '-64px';
}, borderRadius, function (_ref4) {
  var size = _ref4.size;
  return size === 'small' && "\n\t\t\tpadding-top: 14px;\n\t\t\tpadding-bottom: 14px;\n\t\t\tpadding-left: var(--spacing-global-space3);\n\t\t\tfont-size: var(--font-size-m2);\n\t\t\tline-height: var(--font-line-height-m2);\n\t\t\tbackground: transparent;\n\t\t";
});
var StyledIconWrapper = exports.StyledIconWrapper = _styledComponents["default"].span.attrs({
  className: "".concat(componentName, "__iconWrapper"),
  'data-testid': "".concat(componentName, "__iconWrapper")
}).withConfig({
  displayName: "styled-dropdown__StyledIconWrapper",
  componentId: "sc-176ty8k-4"
})(["display:flex;pointer-events:none;align-items:center;"]);
var StyledIcon = exports.StyledIcon = (0, _styledComponents["default"])(_iconElement.Icon).attrs({
  className: "".concat(componentName, "__icon"),
  'data-testid': "".concat(componentName, "__icon")
}).withConfig({
  displayName: "styled-dropdown__StyledIcon",
  componentId: "sc-176ty8k-5"
})(["margin:0;"]);
var StyledExpandIcon = exports.StyledExpandIcon = (0, _styledComponents["default"])(_iconElement.Icon).attrs({
  className: "".concat(componentName, "__expandIcon"),
  'data-testid': "".concat(componentName, "__expandIcon")
}).withConfig({
  displayName: "styled-dropdown__StyledExpandIcon",
  componentId: "sc-176ty8k-6"
})(["margin:0 var(--spacing-global-space3);"]);
var StyledDescriptionContainer = exports.StyledDescriptionContainer = _styledComponents["default"].div.attrs({
  className: "".concat(componentName, "__description"),
  'data-testid': "".concat(componentName, "__description")
}).withConfig({
  displayName: "styled-dropdown__StyledDescriptionContainer",
  componentId: "sc-176ty8k-7"
})(["display:flex;justify-content:flex-start;padding-top:var(--spacing-global-space3);"]);
var StyledHelperText = exports.StyledHelperText = (0, _styledComponents["default"])(_typography["default"]).attrs({
  className: "".concat(componentName, "__helperText"),
  'data-testid': "".concat(componentName, "__helperText")
}).withConfig({
  displayName: "styled-dropdown__StyledHelperText",
  componentId: "sc-176ty8k-8"
})(["color:", ";flex:1 1 auto;"], function (_ref5) {
  var state = _ref5.state;
  return (helperTextColor === null || helperTextColor === void 0 ? void 0 : helperTextColor[state]) || "var(--color-global-grey800)";
});